module.exports = __webpack_public_path__ + "img/star_1.eaf167a0.jpg";